import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { moreTestimonials } from '../data/testimonials';
export function MoreTestimonials() {
  return <section aria-label="Altre testimonianze" className="mx-auto mt-12 w-full max-w-5xl" data-id="element-113" data-mp="20fowudtw93h2">
      <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-114" data-mp="25ausi4d3lwic">
        💜 Altri studenti che hanno già imparato il coreano
      </h2>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-115" data-mp="1cl5pjlgtvme3">
        {moreTestimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i % 2 * 0.1} data-id="element-116" data-mp="1hjywev1m0f5a" data-mpi={i} />)}
      </div>
    </section>;
}